<template>
    <div class="tw-flex tw-flex-wrap">
        <a v-for="board in items" :key="board.id" :href="board.available ? '/boards/' + board.slug : '#'" class="tw-mr-2 tw-mb-2 tw-text-sm tw-font-semibold tw-text-white tw-px-4 tw-py-3 hover:tw-opacity-75 tw-rounded" :class="{'tw-opacity-25': !board.available}"
           :style="{backgroundColor: board.color ? board.color : '#696969'}">
            <i v-if="board.type === 'moodboard'" class="fa tw-pr-1" :class="board.icon"></i>
            {{ board.name }}
        </a>
    </div>
</template>

<script>
    export default {
        name: 'SearchBoard',

        props: {
            items: {
                required: true,
            },
            extended: {
                required: true,
                default: false,
            }
        }
    }
</script>